import { RouteRecordRaw } from 'vue-router';
import AppLayout from '@/app/layouts/AppLayout.vue';

// Import all app route modules
import { route as homeRoute } from './home';
import { route as generateRecordRoute } from './generate-record';
import { route as fillRecordRoute } from './fill-record';
import { route as fillLogsRoute } from './fill-logs';
import { route as editRecordRoute } from './edit-record';
import { route as viewRecordRoute } from './view-record';
import { route as approvalsRoute } from './approvals';
import { route as approvalDocumentRoute } from './approval-document';
import { route as approvalRecordViewRoute } from './approval-record-view';
import { route as documentManagementRoute } from './document-management';
import { route as masterListRoute } from './master-list';
import { route as documentRoute } from './document';
import { route as dashboardRoute } from './dashboard';
import { route as homologationRoute } from './homologation';
import { route as homologationDocumentRoute } from './homologation-document';
import { route as homologationRecordRoute } from './homologation-record';
import { route as profileRoute } from './profile';
import { route as searchRoute } from './search';
import { route as verificationRoute } from './verification';
import { route as verificationDocumentRoute } from './verification-document';
import { route as verificationRecordViewRoute } from './verification-record-view';
import { route as trainingRoute } from './training';
import { route as trainingCreateRoute } from './training-create';
import { route as trainingViewRoute } from './training-view';
import { route as trainingEditRoute } from './training-edit';
import { route as trainingControlRoute } from './training-control';
import { route as trainingMatrixGenerateReportRoute } from './training-matrix-generate-report';
import { route as trainingMatrixEditIndividualRoute } from './training-matrix-edit-individual';
import { route as trainingMatrixEditBatchRoute } from './training-matrix-edit-batch';
import { route as notificationRoute } from './notification';
import { route as historyRoute } from './history';
import { route as testContentRoute } from './test-content';
import { route as registryManagementRoute } from './registry-management';
import { route as viewModelRoute } from './view-model';
import { route as recordConfigRoute } from './record-config';
import { route as viewDraftRoute } from './view-draft';
import { route as viewRejectedRoute } from './view-rejected';
import { route as reminderHistoryRoute } from './reminder-history';
import { route as sandboxRoute } from './sandbox';
import { route as matrixFillPocRoute } from './matrix-fill-poc';
import { route as operationLogsRoute } from './operation-logs';
import { route as directoriesRoute } from './directories';
import { route as directoryRecordViewRoute } from './directory-record-view';

export const routeName = 'App';

export const route: RouteRecordRaw = {
  path: '/',
  component: AppLayout,
  children: [
    directoriesRoute,
    directoryRecordViewRoute,
    homeRoute,
    generateRecordRoute,
    fillRecordRoute,
    fillLogsRoute,
    editRecordRoute,
    viewRecordRoute,
    approvalsRoute,
    approvalDocumentRoute,
    approvalRecordViewRoute,
    documentManagementRoute,
    masterListRoute,
    documentRoute,
    dashboardRoute,
    homologationRoute,
    homologationDocumentRoute,
    homologationRecordRoute,
    profileRoute,
    searchRoute,
    verificationRoute,
    verificationDocumentRoute,
    verificationRecordViewRoute,
    trainingRoute,
    trainingCreateRoute,
    trainingViewRoute,
    trainingEditRoute,
    trainingControlRoute,
    trainingMatrixGenerateReportRoute,
    trainingMatrixEditIndividualRoute,
    trainingMatrixEditBatchRoute,
    notificationRoute,
    historyRoute,
    testContentRoute,
    registryManagementRoute,
    viewModelRoute,
    recordConfigRoute,
    viewDraftRoute,
    viewRejectedRoute,
    reminderHistoryRoute,
    sandboxRoute,
    matrixFillPocRoute,
    operationLogsRoute,
  ],
};
